import { Stack, useLocalSearchParams } from 'expo-router';
import { Platform } from 'react-native';
import LandingScreenV2 from '../src/screens/LandingScreenV2';
import LandingScreen from '../src/screens/LandingScreen.js';
import { landingV2Content } from '../src/constants/landingV2Content';
import { getContentForVariant } from '../src/constants/landingV2Variants';
import { LandingHead } from '../src/components/landing-v2/seo/LandingHead';

export default function Index() {
  const { v: variant } = useLocalSearchParams();
  const variantKey = typeof variant === 'string' ? variant : undefined;

  // LandingScreenV2 is a DOM tree (div/a/img). Native runtimes cannot render
  // those host components, so the launch route falls back to the React Native
  // LandingScreen on iOS/Android even though the project is web-first.
  if (Platform.OS !== 'web') {
    return (
      <>
        <Stack.Screen options={{ headerShown: false }} />
        <LandingScreen variant={variantKey} />
      </>
    );
  }

  const { content, variantLabel, onboardingIntent } = getContentForVariant(landingV2Content, variantKey);
  const onboardingHref = onboardingIntent ? `/onboarding?intent=${encodeURIComponent(onboardingIntent)}` : '/onboarding';

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <LandingHead content={content} canonical="https://doocars.com/" />
      <LandingScreenV2 content={content} variant={variantLabel} onboardingHref={onboardingHref} />
    </>
  );
}
